import { render, staticRenderFns } from "./channelReferenceModal.vue?vue&type=template&id=c6430148&scoped=true"
import script from "./channelReferenceModal.vue?vue&type=script&lang=js"
export * from "./channelReferenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6430148",
  null
  
)

export default component.exports